export const getCollectionPrefix = () => {
  const origin = window.location.origin;
  if (origin.includes('controlote.com')) {
    return '';
  }
  return 'test-';
};
